import EmmyAdvisor from "@/components/EmmyAdvisor";

export default function AdvisorChat() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
      <EmmyAdvisor variant="full" />
    </div>
  );
}
